import React from 'react'

function NotFound() {
  return (
    <div className="text-center text-danger my-3"><b>URL Not Found !</b></div>
  )
}

export default NotFound